import React, {FC} from "react"

import BaseSvgIcon, {type BaseProps} from "../Base"

interface Props extends Omit<BaseProps, "color"> {
  color?: string
}

const ShieldCheck: FC<Props> = ({color, ...props}) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 24 24">
      <path
        fill={color || "currentColor"}
        stroke="none"
        d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
      />
      <path stroke="white" fill="none" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" d="m9 12 2 2 4-4" />
    </BaseSvgIcon>
  )
}

export default ShieldCheck
